import {createStore} from 'redux';
import apReducers from './redux/reducers/index';

const store = createStore(apReducers);
export default store;
